// @ts-check
import React from 'react';
import InputContainer from './InputContainer';
import Link from './Link';
import config from '~/config';

import './LoginButton.scss';

/**
 * @typedef LoginFormBusinessQ2BankingProps
 * @property {import('~/templates/hero/PageHeroLoginForm').PageHeroLoginFormOptionsWith$} options
 */
/** @type {import('~/types/React').ReactFC<LoginFormBusinessQ2BankingProps>} */
const LoginFormBusinessQ2Banking = ({ options }) => {
	if (!config.Q2Endpoint) {
		console.error('Cannot find Q2Endpoint');
	}

	return (
		<React.Fragment>
			<form className="BOLoginForm" method="POST" id="Q2OnlineLogin" name="Q2OnlineLogin" action={config.Q2Endpoint}>
				<InputContainer icon="business">
					<label htmlFor="user_id" tabIndex={-1}>
						{options.username_placeholder}
					</label>
					<input
						className=""
						type="text"
						name="user_id"
						id="user_id"
						autoComplete="off"
						{...options.$?.username_placeholder}
					/>
				</InputContainer>
				<InputContainer icon="lock">
					<label htmlFor="password" tabIndex={-1}>
						{options.password_placeholder}
					</label>
					<input
						type="password"
						name="password"
						id="password"
						autoComplete="off"
						{...options.$?.password_placeholder}
					/>
				</InputContainer>
				<input
					className="BOLoginSubmitButton login-button btn"
					type="submit"
					value={options.button_text ?? 'Login'}
					id="submit-button"
					{...options.$?.button_text}
				/>
			</form>
			<div style={{ textAlign: 'center', paddingTop: '0.5rem', paddingBottom: '1rem' }}>
				{!!options.links?.[0] && (
					<Link to={options.links[0].link_url} {...options.links[0].$?.link_url}>
						{options.links[0].link_text}
					</Link>
				)}
				{!!options.links?.[1] && (
					<>
						<span> | </span>
						<Link to={options.links[1].link_url} {...options.links[1].$?.link_url}>
							{options.links[1].link_text}
						</Link>
					</>
				)}
			</div>
		</React.Fragment>
	);
};

/** @type {import('~/types/React').ReactFC<import('gatsby').HeadProps>} */
const Q2Head = ({ location }) => {
	const Q2_FORM_Pages = ['/login/business/', '/business/'];

	// We only want to inject this business form info on specific pages.
	if (location?.pathname && !Q2_FORM_Pages.includes(location.pathname)) {
		return null;
	}

	return <script type="text/javascript" src="https://cds-sdkcfg.onlineaccess1.com/common.js"></script>;
};

export default LoginFormBusinessQ2Banking;
export const Head = Q2Head;
